module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container admin"
  }, [_c('router-view'), (_vm.$route.fullPath === "/admin") ? [_c('h1', [_vm._v("系统管理")]), (_vm.$permission.has("system.users.edit")) ? _c('router-link', {
    staticClass: "ui button blue icon labeled",
    attrs: {
      "to": '/admin/users'
    }
  }, [_c('i', {
    staticClass: "ui icon users"
  }), _vm._v("用户管理")]) : _vm._e(), (_vm.$permission.has("system.templates.edit")) ? _c('router-link', {
    staticClass: "ui button teal icon labeled",
    attrs: {
      "to": '/admin/templates'
    }
  }, [_c('i', {
    staticClass: "ui icon file"
  }), _vm._v("模板管理")]) : _vm._e(), (_vm.$permission.has("system.meta.edit")) ? _c('router-link', {
    staticClass: "ui button teal icon labeled",
    attrs: {
      "to": '/admin/meta'
    }
  }, [_c('i', {
    staticClass: "ui icon file"
  }), _vm._v("资料管理")]) : _vm._e(), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), (!_vm.$media.isMobile && _vm.$permission.has("*")) ? _c('div', [_vm._m(0), _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "four fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("备份/恢复")]), _c('div', {
    staticClass: "ui red buttons"
  }, [_c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.backup()
      }
    }
  }, [_vm._v("备份数据")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.restore_show()
      }
    }
  }, [_vm._v("恢复数据")])])]), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("补丁")]), _c('div', {
    staticClass: "ui orange buttons"
  }, [_c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.patch("roles/update")
      }
    }
  }, [_vm._v("更新角色权限信息")])])])])]), _c('el-dialog', {
    attrs: {
      "visible": _vm.restore_dialog_visible,
      "title": "恢复数据"
    },
    on: {
      "update:visible": function($event) {
        _vm.restore_dialog_visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("选择备份")]), _c('el-select', {
    attrs: {
      "placeholder": "选择备份"
    },
    model: {
      value: (_vm.restore_dialog_selected),
      callback: function($$v) {
        _vm.restore_dialog_selected = $$v
      },
      expression: "restore_dialog_selected"
    }
  }, _vm._l((_vm.backups), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.restore_dialog_visible = false
      }
    }
  }, [_vm._v("取消")]), _c('div', {
    staticClass: "ui button orange",
    class: {
      disabled: !_vm.restore_dialog_selected
    },
    on: {
      "click": function($event) {
        _vm.restore()
      }
    }
  }, [_vm._v("恢复数据")])])])], 1) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "icon warning"
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("危险区")]), _c('p', [_vm._v("请谨慎进行以下操作，操作不当可能导致数据损坏或丢失。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249a296d","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Admin.vue
// module id = 282
// module chunks = 0